{
  "name": "outlook-web",
  "private": true,
  "version": "2.5.0",
  "type": "module",
  "packageManager": "yarn@4.18.0",
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "postinstall": "husky",
    "dev": "vite",
    "build": "tsc && vite build && yarn build:postprocess",
    "build:postprocess": "./scripts/generate_build_version.sh && node ./scripts/build_launch_events_windows.js",
    "test": "NODE_ENV=test vitest --reporter=verbose --silent",
    "test:ci": "NODE_ENV=test vitest run --reporter=verbose --silent",
    "lint": "biome check --error-on-warnings",
    "lint:fix": "biome check --write --error-on-warnings",
    "preview": "vite preview",
    "release:notes": "sh scripts/release-notes.sh",
    "setup": "bash scripts/setup-dev.sh",
    "setup:ci": "bash scripts/setup-ci.sh",
    "codegen": "./scripts/codegen.sh",
    "generate:manifest": "./scripts/generate_manifest.sh",
    "deps:start": "docker-compose -f docker-compose.local.yaml up -d",
    "deps:stop": "docker-compose -f docker-compose.local.yaml down",
    "deploy:dev": "yarn build && firebase deploy --only hosting:cal-outlook-dev",
    "deploy:qa": "firebase hosting:clone cal-outlook-dev:live cal-outlook-qa:live",
    "types:debug": "tsc --noEmit --noErrorTruncation --diagnostics && tsc --noEmit -p tsconfig.node.json --noErrorTruncation --diagnostics",
    "lint:ci": "biome ci --error-on-warnings --colors=off",
    "format": "biome format --write",
    "types:ci": "tsc --noEmit && tsc --noEmit -p tsconfig.node.json"
  },
  "dependencies": {
    "@calven/lib-service-service-requests-dto": "1.0.0",
    "@emotion/react": "^11.11.4",
    "@emotion/styled": "^11.11.5",
    "@hookform/resolvers": "^5.9.1",
    "@mui/icons-material": "^7.3.11",
    "@mui/material": "^7.3.11",
    "@mui/system": "^7.3.11",
    "@mui/x-date-pickers": "^8.29.3",
    "@reduxjs/toolkit": "^2.12.0",
    "@segment/analytics-next": "^1.73.0",
    "@sentry/react": "^10.74.0",
    "algoliasearch": "^4.24.0",
    "dompurify": "^3.4.15",
    "firebase": "^11.5.0",
    "i18next": "^24.2.3",
    "i18next-browser-languagedetector": "^8.0.0",
    "i18next-http-backend": "^3.0.5",
    "launchdarkly-react-client-sdk": "^3.9.4",
    "lodash": "^4.18.1",
    "luxon": "^3.4.4",
    "notistack": "^3.0.2",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "react-hook-form": "^7.88.0",
    "react-i18next": "^15.7.4",
    "react-instantsearch": "^7.49.0",
    "react-redux": "^9.3.0",
    "react-router-dom": "^6.30.6",
    "react-window": "^2.3.1",
    "type-fest": "^4.21.0",
    "yup": "^1.7.1"
  },
  "devDependencies": {
    "@babel/core": "^7.29.7",
    "@babel/preset-env": "^7.29.7",
    "@biomejs/biome": "^2.5.13",
    "@rolldown/plugin-babel": "^0.2.4",
    "@rtk-query/codegen-openapi": "^1.2.0",
    "@sentry/vite-plugin": "^5.4.0",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@types/lodash.merge": "^4.6.9",
    "@types/luxon": "^3.4.2",
    "@types/node": "^22.20.2",
    "@types/office-js": "^1.0.401",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-istanbul": "^5.0.1",
    "babel-plugin-react-compiler": "^1.0.0",
    "dotenv": "^16.4.5",
    "esbuild": "^0.28.2",
    "esbuild-runner": "^2.2.2",
    "husky": "^9.0.11",
    "jsdom": "^26.1.0",
    "lint-staged": "^15.2.7",
    "office-addin-mock": "^2.4.3",
    "typescript": "^7.0.2",
    "uuid": "^11.1.1",
    "vite": "^8.3.0",
    "vite-plugin-mkcert": "^2.1.0",
    "vitest": "^5.0.1"
  },
  "lint-staged": {
    "!(*.d).(ts|tsx)": [
      "biome check --write --no-errors-on-unmatched --error-on-warnings"
    ]
  }
}
